import {Fragment} from 'react';

import {kebabCase} from 'lodash';

const generateElementId = (elementName, index) => {
  if (!index) return elementName;

  const convertedIndex = kebabCase(index);

  return `${elementName}--${convertedIndex}`;
};

export default generateElementId;

export function newLineHtml(text) {
  const htmlText = text.split('\n').map((item, index) => {
    const contentSplit = item.split('<strong>');
    let contentDiv = null;
    if (contentSplit.length % 2 === 1 && contentSplit.length !== 1) {
      contentDiv = (
        <>
          {contentSplit.map((item, id) => {
            if (id % 2 === 0) return <Fragment key={String(index) + String(id)}>{item}</Fragment>;
            return <strong key={String(index) + String(id)}>{item}</strong>;
          })}
        </>
      );
    } else contentDiv = item;
    return (
      // eslint-disable-next-line react/no-array-index-key
      <Fragment key={index}>
        {contentDiv}
        <br />
      </Fragment>
    );
  });
  return htmlText;
}
